export function modalInputClass(options = {}) {
  const { error = false, withActions = false, clickable = false, readonly = false } = options;

  return [
    'secrets-modal-input',
    withActions && 'secrets-modal-input--with-actions',
    clickable && 'secrets-modal-input--clickable',
    readonly && 'secrets-modal-input--readonly',
    error && 'secrets-modal-input--error',
  ]
    .filter(Boolean)
    .join(' ');
}
